import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { QueryParamsService } from '@services/query-params/query-params.service';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LOCALE } from '@constants/default-locale.const';
import { QUERY_PARAMS } from '@constants/query-params.const';
import { SUPPORTED_LOCALES, SupportedLocale } from '@constants/supported-locales.const';
import { catchError, of } from 'rxjs';

export const APP_INITIALIZERS: (Provider | EnvironmentProviders)[] = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [QueryParamsService, TranslateService],
    useFactory: (queryParams: QueryParamsService, translate: TranslateService) => {
      const fallbackLocale = translate.getBrowserLang() || DEFAULT_LOCALE;

      return () => {
        const requestedLocale = queryParams.get(QUERY_PARAMS.LANG, fallbackLocale);
        const locale = SUPPORTED_LOCALES.includes(requestedLocale as SupportedLocale)
          ? requestedLocale
          : DEFAULT_LOCALE;

        return translate.use(locale).pipe(catchError(() => of(null)));
      };
    },
  },
];
